import React from 'react';
import { withPosterFrame } from '../../utils/videoAnalysis';

export interface VideoBubbleProps {
  url: string;
  label: string;
  thumbnail?: string;
  isDark?: boolean;
}

function encodeUrlSpaces(url: string): string {
  return url.replace(/ /g, '%20');
}

const VideoBubble: React.FC<VideoBubbleProps> = ({ url, label, thumbnail, isDark = false }) => {
  // #t=0.1 fragment = iOS Safari poster-frame fallback when `thumbnail` is absent.
  const src = withPosterFrame(encodeUrlSpaces(url));
  return (
    <figure
      className={`not-prose w-full rounded-2xl overflow-hidden shadow-sm border ${
        isDark ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-100'
      }`}
    >
      <video
        controls
        playsInline
        preload="metadata"
        poster={thumbnail}
        className="block w-full max-w-full h-auto bg-black"
      >
        <source src={src} />
      </video>
      {label && (
        <figcaption
          className={`px-3 py-2 text-xs ${
            isDark ? 'text-gray-300' : 'text-gray-600'
          }`}
        >
          {label}
        </figcaption>
      )}
    </figure>
  );
};

export default VideoBubble;
